import { api } from "./client";

/**
 * Foam line thresholds — the bands behind the foam diagram's colors.
 *
 * Every field is nullable, and null is a real state: "nobody has told us what
 * normal is here". The diagram draws an unconfigured band grey rather than
 * guessing, so these start empty and are filled in on the Settings page.
 */
export type FoamSettings = {
  /** Butane high pressure: normal running band. */
  hp_running_min: number | null;
  hp_running_max: number | null;
  /** Above this the high pressure side is past its safety limit (red). */
  hp_safety_max: number | null;
  /** Butane low pressure: normal running band. */
  lp_running_min: number | null;
  lp_running_max: number | null;
  /** Cooling water: normal temperature band. */
  temp_min: number | null;
  temp_max: number | null;
  updated_at?: string;
};

export function getFoamSettings(signal?: AbortSignal) {
  return api
    .get<FoamSettings>("/settings/foam", { signal })
    .then((r) => r.data);
}

/** Any subset of the fields; an explicit null clears that threshold. */
export function patchFoamSettings(
  body: Partial<Omit<FoamSettings, "updated_at">>,
  signal?: AbortSignal
) {
  return api
    .patch<FoamSettings>("/settings/foam", body, { signal })
    .then((r) => r.data);
}
